import { useInfiniteQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { DedicatedEngineListQuery } from '@rossum/api-client/dedicatedEngines';
import { api } from '../../../lib/apiClient';
import { resolveNextPageParam } from '../../../lib/resolveNextPageParam';
import { dedicatedEngineKeys } from '../keys';

export const useInfiniteDedicatedEngines = (query: DedicatedEngineListQuery) =>
  useInfiniteQuery({
    queryKey: dedicatedEngineKeys.list(query),
    queryFn: ({ pageParam = 1 }) =>
      api.request(
        endpoints.dedicatedEngines.list({
          ...query,
          page: pageParam,
        })
      ),
    getNextPageParam: resolveNextPageParam,
  });
